import React, { useEffect, useState ,useRef} from "react";
import BottomNav from "../components/BottomNav";
import Container from "../components/Container";
import Description from "../components/Description";
import FinancialHealthCheckup from "../components/FinancialHealthCheckup";
import Heading from "../components/Heading";
import Input from "../components/Input";
import PieGraph2 from "../components/PieGraph2";
import PieGraph from "../components/PieGraph";
import ResultInput from "../components/ResultInput";
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Cell, ResponsiveContainer } from 'recharts';
import PieGraph3 from "../components/PieGraph3";
import DescriptionItem from "../components/DescriptionItem";
import {useSelector,useDispatch} from 'react-redux'
import  { actions } from '../store/index'
import YourFHC from "../components/YourFHC";
import { Link } from "react-router-dom";


const KFormater = (num) => Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill="#0A1827" textAnchor="middle" dy={value < 0 ? 16 : -6} >{`${value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}</text>;
};

const VP = () => {
    const counter=useSelector((state)=>state.formdata)
    const dispatch=useDispatch()
    const hasCodeExecuted = useRef(false);
    const [selects,setselects]=useState();
    

    const [formData, setFormData] = useState({
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        T1: 0,
        T2: 0,
        T3: 0,
        T4: 0,
  

     
    
    });

    const [data,setData]=useState({
        F1: 0,
        F2: 0,
        F3: 0,
        F4: 0,
        VS1: 0,
        VS2: 0,
        VS3: 0,
        VS4: 0,
        VS5: 0,
        VS6: 0
    })
    
    const [resultData, setResultData] = useState({
        R1: 0,
        R2: 0,
        R3: 0,
        R4: 0,
        R5: 0,
        TE: 0,
        TFC: 0,
        AVS: 0,
        TVC: 0,
        Surplus: 0,
        S:0
    });


    const [Slack, setSlack] = useState(0);
    const [Slack2, setSlack2] = useState(0);
    const [Networth, setNetworth] = useState(0);

    const changeHandler = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const dataChangeHandler = (e) => {

        setData({
            ...data,
            [e.target.id]: e.target.value
        });

     

    };

    const update=()=>
    {
        Object.keys(counter).length>0?
        setFormData(counter):
        setFormData(formData)
    }

    useEffect(() => {
        if (!hasCodeExecuted.current) {

            update()
            hasCodeExecuted.current = true;

            window.scrollTo(0, 0);

        }

        const { M1, M2, M3, M4, T1, T2, T3, T4} = formData;
        const {F1,F2,F3,F4, VS1,VS2,VS3,VS4,VS5,VS6 }=data;
        setResultData({
            R1: (Number(M3) / Number(M1))*100 ,
            R2: Number(T1) / (Number(M2) + Number(M3) + Number(M4))*100,
            R3: ((Number(T1) + Number(T2)) / (Number(T3) + Number(T4)))*100,
            R4: (Number(T1) / (Number(M3) + Number(M4)) )*100,
            R5: (Number(M4) / Number(M1) )*100,
            TFC: Number(F1)+Number(F2)+Number(F3)+Number(F4),
            TVC:Number(VS1)+Number(VS2)+Number(VS3)+Number(VS4)+Number(VS5)+Number(VS6),
            AVS: Number(M1)-Number(M3)-Number(M4)-(Number(F1)+Number(F2)+Number(F3)+Number(F4)),
            Surplus: Number(resultData.AVS)-Number(VS1)-Number(VS2)-Number(VS3)-Number(VS4)-Number(VS5)-Number(VS6)
            
        });
        setCartData([{
            name: 'Total Savings',
            value: Number(T1),
            color: "green"
        },
        {
            name: 'Investments',
            value: Number(T2),
            color: "green"
        },
        {
            name: 'Total Debt',
            value: -Number(T3),
            color: "red"
        },
        {
            name: 'Mortgage',
            value: -Number(T4),
            color: "pink"
        }]);
    dispatch(actions.updateFormData(formData))

        setSlack(Number(M1) - (Number(M2) + Number(M3) + Number(M4)));
        // alert(resultData.TVC)
        setSlack2(Number(M1)-Number(M3)-Number(M4)-Number(resultData.TFC)-Number(resultData.TVC))
        setNetworth((Number(T1) + Number(T2)) - Number(T3));
    }, [formData, Slack,Slack2,data]);

    const [chartData, setCartData] = useState([{
        name: 'Total Savings',
        value: Number(formData.T1),
        color: "green"
    },
    {
        name: 'Investments',
        value: Number(formData.T2),
        color: "green"
    },
    {
        name: 'Total Debt',
        value: -Number(formData.T3),
        color: "red"
    },
    {
        name: 'Mortgage',
        value: -Number(formData.T4),
        color: "pink"
    }]);

    return (
        <div className="w-full ">
            <div className="bg-gradient-to-b h-72 from-primary to-patric-blue">
                <Container classes={"flex flex-col p-4 px-5 space-y-6 md:space-y-0  md:py-10 md:flex-row items-center w-full justify-between"}>
                    <div className="w-full md:w-auto">
                        <Link to={'/'}>
                        
                        <img src="./assets/images/logo-white.png" alt="logo" />
                        </Link>
                        
                        </div>
                    <h1 className="text-white font-bold text-center text-2xl md:text-4xl">Value Spending</h1>
                    <div className="hidden md:block"></div>
                </Container>
                <div className="text-white  text-center mb:mx-0 mx-5 md:ml-40 -mt-3 md:-mt-7 text-lg md:text-2xl">Love life, not a budget. Prioritize your values in your spending plan </div>

            </div>
            <Container classes={"-mt-24 md:-mt-32 py-10 space-y-6"}>
            <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                        <div className="shadow-md p-6 bg-white space-y-6">
                            <Heading text={"Basic Financial Inputs "} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"M1"} value={formData.M1} label={"Monthly Income"} onChange={changeHandler} />
                                <Input type={"number"} id={"T1"} value={formData.T1} label={"Total Savings (Liquid Funds)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M2"} value={formData.M2} label={"Monthly Expenses"} onChange={changeHandler} />
                                <Input type={"number"} id={"T2"} value={formData.T2} label={"Stocks, bonds, real estate etc."} onChange={changeHandler} />
                                <Input type={"number"} id={"M3"} value={formData.M3} label={"Monthly Debt pmt (credit card, car etc)"} onChange={changeHandler} />
                                <Input type={"number"} id={"T3"} value={formData.T3} label={"Total Debt (except mortgage)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M4"} value={formData.M4} label={"Housing / Rent, Tax, Inurance"} onChange={changeHandler} />
                                <Input type={"number"} id={"T4"} value={formData.T4} label={"Mortgage Balance"} disable onChange={changeHandler} />
                            </div>

                           
                        </div>

                      
              <YourFHC R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Slack={Slack}/>

                        
                        
                        
                    </div>

                </div>



                      <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                    <div className="shadow-md p-6 bg-white space-y-7 md:w-6/12">
                            <Heading text={"Monthly Fixed Costs"} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"F1"} value={data.F1} label={"Transportation (car loan + gas)"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"F4"} value={data.F4} label={"Any other (saving goals etc.)"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"F2"} value={data.F2} label={"Food (groceries & related food)"} onChange={dataChangeHandler} />
                                <ResultInput type={"number"}   label={"Total fixed Costs"}  value={isNaN(resultData.TFC) || resultData.TFC === Infinity ? 0 :  resultData.TFC.toFixed(0)}/>
                                <Input type={"number"} id={"F3"} value={data.F3} label={"Utilities(electricity, gas, internet, etc.)"} onChange={dataChangeHandler} />
                                <ResultInput type={"number"} id={"AVS"}  label={"Amt. available for value spending"} value={isNaN(resultData.AVS) || resultData.AVS === Infinity ? 0 :  resultData.AVS.toFixed(0)} isLast/>
                            </div>
                            </div>
                        
                        
                        <div className="shadow-md p-6 bg-white space-y-6 md:w-6/12">
                            <Heading text={"Value Spending (monthly amounts)"} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20  ">
                                <Input type={"number"} id={"VS1"} value={data.VS1} label={"Books"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"VS4"} value={data.VS4} label={"Shopping"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"VS2"} value={data.VS2} label={"Travel"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"VS5"} value={data.VS5} label={"Send money to parents"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"VS3"} value={data.VS3} label={"Eating out"} onChange={dataChangeHandler} />
                                <Input type={"number"} id={"VS6"} value={data.VS6} label={"Others"} onChange={dataChangeHandler} />
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-1 md:ml-48">
                            <ResultInput label={"Total Variable Costs"} value={isNaN(resultData.TVC) || resultData.TVC === Infinity ? 0 :  resultData.TVC.toFixed(0)} isLast />


                            </div>
                        </div>
                            

                        
                        
                      </div>
                      </div>




                      <div className="block md:flex   px-5">

               <div className="hidden md:block w-7/12">
               <PieGraph heading="Expenses & Surplus"  M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                   </div>
                  <div className="md:hidden">
               <PieGraph heading="Expenses & Surplus"  M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                 </div>
                 <div className="md:pl-14 mt-10 md:mt-24">
                    { resultData.R1>40 ? <DescriptionItem falseText={"Your monthly Debt payments are high compared to your Income."} rightText={""} condition={resultData.R1 <= 40} /> : null}
                    <br></br>
                    { formData.T3> (0.3*(Number(formData.T1))+Number(formData.T2)) ? <DescriptionItem falseText={"You may have very high Total debt."} rightText={""} condition={formData.T3< (0.3*(Number(formData.T1))+Number(formData.T2))} /> : null}
                    <br></br>
                    { (resultData.R1<40 && formData.T3 < (0.3*(Number(formData.T1))+Number(formData.T2))) ? <DescriptionItem falseText={""} rightText={"Your monthly Debt payments are manageable given your Income and your Total Debt is reasonable."} condition={resultData.R1<40 & formData.T3 < (0.3*(Number(formData.T1))+Number(formData.T2)) } /> : null}
                    <br></br>
                    { !(isNaN(resultData.R2) || resultData.R2 === Infinity || resultData.R2<0)? <DescriptionItem falseText={"You have less than 3 months of Total Savings to cover your expenses and debt obligations."} rightText={"You have 3+ months of Total savings to cover expenses and debt payments. Maintain this as your emergency fund."} condition={(Number(resultData.R2)>300)} />:null}
                  </div> 

 </div> 

 <div className="hidden md:block    ">
               <PieGraph2 heading="Fixed Costs vs Surplus"  Surplus={resultData.Surplus} AVS={resultData.AVS} />
                   </div>
                  <div className="md:hidden">
               <PieGraph2  heading="Fixed Costs vs Surplus"  Surplus={resultData.Surplus>0?resultData.Surplus:0} AVS={resultData.AVS>0?resultData.AVS:0} />
                 </div>
                  

                 <div className="md:flex justify-between md:space-x-24 pt-10">
<div className="w-full md:flex-1 p-5  shadow-md   ">
    <div className="px-0 md:px-20">

        <Heading text="Key Financial Metrics" classes={"items-center px-10 md:px-10 "} />
    </div>
    <div className="flex justify-center">

     
    </div>
    <div className="flex justify-center p-5 ">
<p className="hidden">{resultData.S=(Number(formData.M1)-Number(formData.M3)-Number(formData.M4)-Number(resultData.TFC)-Number(resultData.TVC))}</p>
        <div className=" md:w-1/2 md:px-0 px-10 space-y-7">
        <ResultInput label={'Debt / Income ratio'} value={isNaN(resultData.R1) || resultData.R1 === Infinity ? 0 :resultData.R1.toFixed(2) +'%'} tooltip={"How much of your income is spent on Debt Payments? Recommended < 20%"} />
            <ResultInput label={'Expense coverage ratio by savings'} value={isNaN(resultData.R2) || resultData.R2 === Infinity ? 0 : resultData.R2.toFixed(2) +'%'}  tooltip={"How many times does your savings cover monthly expenses(expenses, debt and rent)? Recommended>300% (3 months)"} />
            <ResultInput label={'Assets / Liabilities'} value={isNaN(resultData.R3) || resultData.R3 === Infinity ? 0 :  resultData.R3.toFixed(2)+'%'}  tooltip={"Ratio of what you have vs what you owe. Recommended>100% (positive net worth)"}/>
            <ResultInput label={'Assets / (Rent + Debt) coverage'} value={isNaN(resultData.R4) || resultData.R4 === Infinity ? 0 :  resultData.R4.toFixed(2)+'%'} tooltip={"How many times can your obligations be covered by assets? Recommended > 1200% (one year) "} />
            <ResultInput label={'Housing cost ratio'} value={isNaN(resultData.R5) || resultData.R5 === Infinity ? 0 : resultData.R5.toFixed(2)+'%'} tooltip={"How much of your income is spent on housing costs? Recommended < 30% "}/>
            <ResultInput label={'Slack in Budget'} value={isNaN(resultData.S) || resultData.S=== Infinity  || Number(resultData.S)<0 ?0 :  resultData.S.toFixed(0)} isLast  tooltip={"This is the surplus each month which can be used for goal planning"}/>
    

        </div>

    </div>
</div>

<div className=" w-full w-9/12 md:w-1/2 pt-5 md:block  justify-center px-0 md:px-0 ">
                            <PieGraph heading="Expenses & Surplus"  M1={formData.M1}  M3={formData.M3} M4={formData.M4} slack={resultData.S} TFC={resultData.TFC} VS={resultData.TVC} />
                        </div>

</div>






                  
                      
                        
                

            
               
                       
                 <div className="pt-10">
                    <BottomNav />
                </div>

            </Container>
        </div>
    );
};

export default VP;